"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function WinkWacky() {
    return (jsx_runtime_1.jsxs("g", __assign({ transform: 'translate(0.000000, 8.000000)' }, { children: [jsx_runtime_1.jsx("circle", { fill: '#FFFFFF', cx: '82', cy: '22', r: '12' }, void 0),
            jsx_runtime_1.jsx("circle", { fillOpacity: '0.699999988', fill: '#000000', cx: '82', cy: '22', r: '6' }, void 0),
            jsx_runtime_1.jsx("path", { fillOpacity: '0.599999964', fill: '#000000', d: 'M16.1601674,25.4473116 C18.006676,21.648508 22.1644225,19 26.9975803,19 C31.8136766,19 35.9591217,21.629842 37.8153518,25.4071242 C38.3667605,26.5291977 37.5821037,27.4474817 36.790607,26.7670228 C34.3395063,24.6597833 30.8587163,23.3437884 26.9975803,23.3437884 C23.2572061,23.3437884 19.8737584,24.5787519 17.4375392,26.5716412 C16.5467928,27.3002944 15.6201012,26.5583844 16.1601674,25.4473116 Z' }, void 0)] }), void 0));
}
exports.default = WinkWacky;
